import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import type { IPopupProps, TField } from '~/src/features/videocontrol/pageBlocks/Cart/types';

/**
 * Данные для результирующего попапа
 *
 * @function
 * @name utils.getPopupResultData
 * @param {boolean} result - результат запроса
 * @param {string} message - сообщение ответа
 * @returns {Omit<IPopupProps, 'isOrderOpened'>}
 */
export const getPopupResultData = ({ result, message } : { result: boolean, message: string }): Omit<IPopupProps, 'isOrderOpened'> => {
    return {
        isResultOpened: true,
        resultType: result ? EResultPopupStatus.SUCCESS : EResultPopupStatus.ERROR,
        resultTitle: result ? 'Заявка отправлена' : 'Произошла ошибка',
        resultText: message || (result ? 'Мы свяжемся с вами в ближайшее время' : 'Что-то пошло не так, попробуйте позже.'),
    };
};

/**
 * Начальное состояние попапа
 *
 * @name utils.initialPopupState
 * @returns {Omit<IPopupProps, 'isOrderOpened'>}
 */
export const initialPopupState: Omit<IPopupProps, 'isOrderOpened'> =  {
    isResultOpened: false,
    resultTitle: '',
    resultText: '',
    resultType: EResultPopupStatus.SUCCESS,
};

/**
 * Изначальное состояние инпутов формы ос
 *
 * @name utils.STATE_DEFAULT_INPUTS
 * @returns {TField}
 */
export const STATE_DEFAULT_INPUTS: TField = {
    value: '',
    isValid: false,
    clearInput: () => undefined,
};
